module.exports = __webpack_public_path__ + "img/_SDI9703-2-1600.452fcc6f.webp";